import Result from "@/core/common/Result";

export interface IBase64ToBlobConvert {
  execute(file: string): Promise<Result<Blob>>;
}

export const Base64ToBlobConvertDI = Symbol("Base64ToBlobConvertDI");
